import { RootState } from 'store';

export const selectFirstChangelogFeature = (state: RootState) =>
  state.services.api.changelog?.features?.[0]?.name;

export const selectChangelogFeatureInfo = (state: RootState, feature: string) =>
  state.services.api.changelog?.features.find(({ name }) => name === feature);
